/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'nav-bar',
	templateUrl: './nav-bar.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBarComponent {
	@Input() public hideLogo = false;
	public you;
	constructor(private router: Router) {}

	public goToProjects(): void {
		this.router.navigate(['/projects']);
	}
}
